var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "开始测试" } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "pic",
        style: {
          background:
            "url(" +
            _vm.EnvUrl +
            _vm.scaleInfoDetail.bigPic +
            ") no-repeat center/cover"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "testTitle" }, [
          _vm._v(_vm._s(_vm.scaleInfoDetail.title) + " ")
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.scaleInfoDetail.content) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "centerBox" }, [
          _c("div", { staticClass: "centerItem" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.scaleInfoDetail.testCountStr) +
                "\n                "
            ),
            _c("div", { staticClass: "itemName" }, [_vm._v("参与人数")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "centerItem" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.scaleInfoDetail.questionCount) +
                "题\n                "
            ),
            _c("div", { staticClass: "itemName" }, [_vm._v("题目数")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "centerItem" }, [
            _vm._v(
              "\n                " +
                _vm._s(Math.ceil(_vm.scaleInfoDetail.questionCount / 10)) +
                "分钟\n                "
            ),
            _c("div", { staticClass: "itemName" }, [_vm._v("建议用时")])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btnBox", on: { click: _vm.getScaleQuestionList } },
          [_vm._v("开始测试")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eede2fda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eede2fda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/testDetail.vue
// module id = null
// module chunks = 